// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsMacosInstancesIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-macos-instances_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      d="M19.01 22.96c0 2.4-1.23 3.88-3.21 3.88s-3.21-1.49-3.21-3.88 1.23-3.87 3.21-3.87 3.21 1.57 3.21 3.87m2.72-8.31-.82.08q-.75 0-.75.5c0 .32.25.49.66.49.5 0 .9-.33.9-.83zM34 20c0 7.82-6.18 14-14 14S6 27.82 6 20 12.18 6 20 6s14 6.18 14 14m-10.79-5.52c0 1.16.66 1.81 1.65 1.81.82 0 1.4-.49 1.48-1.15h-.66c-.08.41-.4.58-.82.58-.58 0-.9-.5-.9-1.24s.32-1.23.9-1.23c.5 0 .74.24.82.57h.66c-.08-.66-.66-1.15-1.48-1.15-.99 0-1.65.74-1.65 1.81m-9.39-1.73v3.46h.66v-2.06c0-.5.33-.82.74-.82.42 0 .66.25.66.66v2.3h.66v-2.22c0-.41.33-.74.74-.74.5 0 .66.25.66.74v2.22h.66v-2.38q-.02-1.14-1.15-1.16c-.5 0-.9.25-1.07.66h-.09a1 1 0 0 0-.98-.66 1 1 0 0 0-1 .66h-.07v-.66zm6.43 10.21c0-3.04-1.73-4.94-4.45-4.94s-4.45 1.9-4.45 4.94 1.73 4.95 4.45 4.95 4.45-1.9 4.45-4.95m.4-6.67c.5 0 .83-.16 1.08-.57h.08v.5h.66V13.9c0-.75-.5-1.16-1.4-1.16-.82 0-1.32.41-1.4 1h.66q.12-.4.74-.42c.5 0 .74.25.74.58v.33h-.99c-.82.08-1.31.4-1.31 1.07 0 .65.49.98 1.15.98m7.59 8.73c0-1.31-.83-2.14-2.8-2.55l-1.08-.25c-1.31-.33-1.8-.82-1.8-1.56 0-.99.9-1.57 2.13-1.57 1.24 0 2.06.66 2.15 1.73h1.23c-.08-1.64-1.4-2.8-3.38-2.8-1.97 0-3.37 1.16-3.37 2.72 0 1.32.82 2.22 2.72 2.64l1.07.24c1.31.33 1.89.83 1.89 1.65 0 .9-.9 1.65-2.22 1.65-1.4 0-2.3-.66-2.47-1.65h-1.24c.08 1.65 1.48 2.72 3.62 2.72 2.15-.08 3.55-1.15 3.55-2.97"
    />
    <defs>
      <linearGradient
        id="aws-macos-instances_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsMacosInstances",
);
export default AwsMacosInstancesIcon;
